<div class="row">
  <h2>Description</h2>
  <span class="contrastedText">{{char.char['description']}}</span>
  <br/>
  <span class="contrastedText">{{char.char['longdescription']}}</span>
</div>

<div class="row">
  <div class="col-1"><h2 id="mainhead">Main </h2>
  @if (char.char['main']) {
    <ul id='main'>
      @for (m of char.char['main'] | keyvalue ; track m) {
        @if (!isEq(''+m.key, 'Glory')) {
          <li>
            <span class="gold" >{{m.key}}</span> {{m.value}}
          </li>
        }
      }
    </ul>
  }

</div> <!-- 33.33% -->
<div class="col-1"><h2 id="stathead">Statistics</h2>
<ul id="statistics">
  <li><span class="gold">SIZ</span>{{char.char['stats']['siz']}}</li>
  <li><span class="gold">DEX</span>{{char.char['stats']['dex']}}</li>
  <li><span class="gold">STR</span>{{char.char['stats']['str']}}</li>
  <li><span class="gold">CON</span>{{char.char['stats']['con']}}</li>
  <li><span class="gold">APP</span>{{char.char['stats']['app']}}</li>
</ul>

</div> <!-- 33.33% -->
<div class="col-1">
  <div>
    <h2 id="stathead">
      {{char.char['name']}}
    </h2>
  </div>
  <div style="text-align: center"><img class="Image-Frame" id='char.charimg' src="{{char.char['url']}}" width="200"> </div>
</div> <!-- 33.33% -->
</div>
<div class="row">
  <div class="col-1">
    <h2 id="traithead">Personality Traits</h2>
    @if (parent.traits && parent.traits.length) {
      <table class="traits">
        @for (t of parent.traits; track t) {
          <tbody><tr>
            <td><mat-checkbox [disabled]="!false" [checked]="isMarked(t.first)" (change)="mark($event.checked, t.first)"></mat-checkbox></td><td
            >@if (false) {
            <app-editable [enabled]="false"
              value="{{char.char['traits'][t.short]}}"
            ></app-editable>
            }@if (!false) {
            {{char.char['traits'][t.short]}}
          }</td><td >{{t.first}}@if (isChivalry(t.first)) {
          <mat-icon>security</mat-icon>
          }@if (isVirtue(t.first)) {
          <mat-icon>emoji_events</mat-icon>
          }</td
          ><td>@if (isVirtue(t.second)) {
          <mat-icon>emoji_events</mat-icon>
        }{{t.second}}</td><td
        ><app-editable  [enabled]="false"
        value="{{20-char.char['traits'][t.short]}}"
        ></app-editable></td><td><mat-checkbox [disabled]="!false" [checked]="isMarked(t.second)" (change)="mark($event.checked, t.second)"></mat-checkbox></td>
      </tr>
      <tr><td></td><td colspan="4"><div><div class="ratioGreen"  style="width:{{5*getTrait(t.short)}}%"></div><div  style="width:{{100-5*getTrait(t.short)}}%" class="ratioRed"></div></div></td><td></td></tr>
    </tbody>
  }
  <tr><td colspan="100%" align="center"> Chivalry: {{chivalry}}/80</td></tr>
</table>
}
</div>
<div class="col-1">
  <h2 class="skillhead">Skills</h2>
  @if (char.char && char.char['skills']) {
    <ul id="skills">
      @for (m of char.char['skills']['Other'] | keyvalue; track m) {
        <li><mat-checkbox [disabled]="!false" [checked]="isMarked(m.key)"
          (change)="mark($event.checked, m.key)"></mat-checkbox><span class="gold">{{m.key}}</span><app-editable
          [enabled]="false"
          value="{{char.char['skills']['Other'][m.key]}}"
        ></app-editable></li>
      }
    </ul>
  }
</div>
<div class="col-1">
  <h2 class="skillhead">Combat Skills</h2>
  @if (char.char && char.char['skills']) {
    <ul id="combat">
      @for (m of char.char['skills']['Weapons'] | keyvalue; track m) {
        <li><mat-checkbox [disabled]="!false" [checked]="isMarked(m.key)" (change)="mark($event.checked, m.key)"></mat-checkbox><span class="gold">{{m.key}}</span><app-editable
        [enabled]="false"
        value="{{char.char['skills']['Weapons'][m.key]}}"
      ></app-editable></li>
    }
    @for (m of char.char['skills']['Combat'] | keyvalue; track m) {
      <li><mat-checkbox [disabled]="!false" [checked]="isMarked(m.key)" (change)="mark($event.checked, m.key)"></mat-checkbox><span class="gold">{{m.key}}</span><app-editable
      [enabled]="false"
      value="{{char.char['skills']['Combat'][m.key]}}"
    ></app-editable></li>
  }
</ul>
}
<h2 id="passionhead">Passions</h2>
<ul id="passions">
  @for (g of char.char['passions'] | passionGroups; track g) {
    @if (g.category !== 'Other') {
      <li class="passion-cat">{{g.category}} (<span [class.passion-warn]="g.total > 40">{{g.total}}</span>)</li>
    }
    @for (m of g.items; track m) {
      <li><mat-checkbox [disabled]="!false" [checked]="isMarked(m.key)" (change)="mark($event.checked, m.key)"></mat-checkbox><span class="gold">{{m.key}}</span><app-editable
      [enabled]="false"
      value="{{char.char['passions'][m.key]}}"
    ></app-editable></li>
  }
}
</ul>
</div>
</div>
